"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = exports.ApiClientGeneric = void 0;
const api_requestor_1 = require("@madbox/api_requestor");
class ApiClientGeneric {
    constructor(config = {}) {
        this._config = {};
        this.init(config);
    }
    init(config = {}) {
        Object.assign(this._config, config);
    }
    get apiRequestor() {
        return this._config.apiRequestor || api_requestor_1.ApiRequestor.instance;
    }
    get url() {
        return this._config.url || this.DEFAULT_API_URL;
    }
    _populateAuthentication(authentication, entityId, defaultAuthType) {
        authentication.entityId = entityId;
        authentication.type = authentication.type || defaultAuthType;
        return authentication;
    }
    get(entityId, defaultAuthType, action, body, authentication) {
        return this.apiRequestor.get(this.url, action, body, this._populateAuthentication(authentication, entityId, defaultAuthType));
    }
    post(entityId, defaultAuthType, action, body, authentication) {
        return this.apiRequestor.post(this.url, action, body, this._populateAuthentication(authentication, entityId, defaultAuthType));
    }
    put(entityId, defaultAuthType, action, body, authentication) {
        return this.apiRequestor.put(this.url, action, body, this._populateAuthentication(authentication, entityId, defaultAuthType));
    }
    delete(entityId, defaultAuthType, action, body, authentication) {
        return this.apiRequestor.delete(this.url, action, body, this._populateAuthentication(authentication, entityId, defaultAuthType));
    }
    download(entityId, defaultAuthType, action, body, authentication) {
        return this.apiRequestor.download(this.url, action, body, this._populateAuthentication(authentication, entityId, defaultAuthType));
    }
    getDownloadUrl(entityId, defaultAuthType, action, body, authentication) {
        return this.apiRequestor.getDownloadUrl(this.url, action, body, this._populateAuthentication(authentication, entityId, defaultAuthType));
    }
}
exports.ApiClientGeneric = ApiClientGeneric;
class ApiClient extends ApiClientGeneric {
}
exports.ApiClient = ApiClient;
